<template>
    <CollapsedDropdown
        v-if="collapsed"
        icon="building"
        :title="currentLocationName ? `Location: ${currentLocationName}` : 'Location'"
    >
        <template #default="{ close }">
            <a
                v-for="location in filteredLocations"
                :key="location.id"
                class="cd-item"
                :class="{
                    active: location.id === selectedLocation,
                    deactivated: location.isDeactivated
                }"
                href="#"
                @click.prevent="
                    selectAndApply(location.id);
                    close();
                "
            >
                {{ location.isDeactivated ? "❌ " : "" }}{{ location.name }}
            </a>
        </template>
    </CollapsedDropdown>
    <div
        v-else
        :class="{
            'sidebar-context-select': useCustomDropdown,
            'page-header-select': inlineLabel
        }"
    >
        <i
            v-if="inlineLabel"
            :class="['fas', `fa-${inlineIcon}`, 'page-header-select__icon']"
            aria-hidden="true"
        ></i>
        <select
            :id="selectId"
            v-model="selectedLocation"
            :class="{
                customdropdown: useCustomDropdown,
                'page-header-select__input': inlineLabel
            }"
            class="form-select"
            :aria-label="inlineLabel ? `${inlineLabel} location` : 'Location Select'"
            @change="setLocationID"
        >
            <option value="" disabled>Select Location</option>
            <option
                v-for="location in filteredLocations"
                :key="location.id"
                :value="location.id"
                :class="{ deactivated: location.isDeactivated }"
            >
                {{ location.isDeactivated ? "❌ " : "" }}{{ location.name }}
            </option>
        </select>
        <label v-if="useCustomDropdown" :for="selectId" class="sidebar-switcher-label">
            Location
        </label>
    </div>
</template>

<script>
import { useId } from "vue";
import { useScopeChoices } from "@/composables/useScopeChoices";
import CollapsedDropdown from "./common/CollapsedDropdown.vue";

export default {
    components: { CollapsedDropdown },
    props: {
        useCustomDropdown: {
            type: Boolean,
            default: true // Default value to apply customdropdown class
        },
        collapsed: {
            type: Boolean,
            default: false
        },
        inlineLabel: {
            type: String,
            default: ""
        },
        inlineIcon: {
            type: String,
            default: "building"
        }
    },
    setup() {
        return { selectId: useId(), ...useScopeChoices() };
    },
    data() {
        return {
            selectedLocation:
                this.$store.state.locationID || localStorage.getItem("location_id") || ""
        };
    },
    computed: {
        filteredLocations() {
            return this.locationChoices.map((location) => ({
                ...location,
                isDeactivated: location.tags?.includes("DEACTIVATED")
            }));
        },
        currentLocationName() {
            const current = this.filteredLocations.find((l) => l.id === this.selectedLocation);
            return current ? current.name : "";
        }
    },
    watch: {
        "$store.state.locationID"() {
            this.selectedLocation = this.$store.state.locationID;
        }
    },
    methods: {
        setLocationID() {
            this.$store.commit("setLocationByID", this.selectedLocation);
            this.$toast.success(`Changed location to ${this.$store.state.location.name}`);
        },
        selectAndApply(id) {
            this.selectedLocation = id;
            this.setLocationID();
        }
    }
};
</script>

<style scoped>
select.customdropdown {
    color: var(--side-nav-control-text, white);
    background-color: var(--side-nav-control-bg, #1a1a1a);
    border-radius: var(--forkto-radius-control);
    border: 1px solid var(--side-nav-control-border, transparent);
}

.deactivated {
    color: gray;
}

select.customdropdown {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: var(--side-nav-select-indicator);
    background-size: 0.75rem;
    background-repeat: no-repeat;
    background-position-x: 90%;
    background-position-y: center;
}

.sidebar-switcher-label {
    color: var(--side-nav-muted, rgba(255, 255, 255, 0.7));
}

.collapsed-switcher-btn {
    background-color: #1a1a1a;
    color: white;
    border: none;
    padding: 0.5rem 0;
}

.collapsed-switcher-btn:hover,
.collapsed-switcher-btn:focus {
    background-color: #2a2a2a;
    color: white;
}

.dropdown-item.deactivated {
    color: gray;
}
</style>
